module.exports = __webpack_public_path__ + "img/frame (259).5f24df8c.jpg";